import React, { Component } from "react";
import Functions from "../../src/functions";
import ReactTags from "react-tag-autocomplete";

class Tag extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: [],
    loaded: false,
    editable: true,
    attributes: "",
    tags: [],
    suggestions: [],
    events: {},
    allowNew: true,
    minQueryLength: 0,
    maxTags: 20,
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = [];
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }
    let allowNew = this.state.allowNew;
    if (this.props.property.configuration) {
      if (this.props.property.configuration.allowNew) {
        allowNew = this.props.property.configuration.allowNew;
      }
    }

    // let value = this.props.value;
    // let values = []
    // values.push(values)

    if (this.props.value) {
      if (typeof this.props.value === "string") {
        try {
          defaultValue = JSON.parse(this.props.value);
        } catch (e) {}
      } else {
        defaultValue = this.props.value;
      }
    }

    this.state = {
      allowNew: allowNew,
      minQueryLength: this.props.property.minQueryLength,
      maxTags: this.props.property.maxTags,
      tags: defaultValue,
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: defaultValue,
    };
  }

  onAddition(tag) {
    const delimiterChars = this.state.delimiters;
    let tagsArray = [];

    if (tag.id) {
      tagsArray = [tag];
    } else {
      tagsArray = tag.name
        .split(new RegExp(delimiterChars.join("|"), "g"))
        .map((itm) => ({
          id: itm.trim(),
          name: itm.trim(),
        }));
    }

    const tags = [...this.state.tags, ...tagsArray];

    this.setState({ tags });

    if (this.onChange) {
      this.onChange(tags);
    }
  }

  onDelete(i) {
    const tags = this.state.tags.slice(0);
    tags.splice(i, 1);
    this.setState({
      tags,
    });
  }

  onInput(query) {
    return;
  }

  componentDidMount() {
    // let values = [];
    // let value = this.props.value
    // values

    this.setState({
      tags: this.state.defaultValue,
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      delimiters: this.props.property.delimiters
        ? this.props.property.delimiters
        : ["Enter", "Tab", ",", ";"],
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }

    if (this.onChange) {
      this.onChange();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  editable() {
    let control = (
      <React.Fragment>
        <ReactTags
          tags={this.state.tags}
          onAddition={this.onAddition.bind(this)}
          onDelete={this.onDelete.bind(this)}
          onInput={this.onInput.bind(this)}
          suggestions={this.state.suggestions}
          allowNew={this.state.allowNew}
          minQueryLength={this.props.property.minQueryLength}
          maxTags={this.props.property.maxTags}
          placeholderText={this.state.placeholder}
          delimiters={this.state.delimiters}
          addOnBlur={true}
          classNames={{
            root: "react-tags",
            rootFocused: "is-focused",
            selected: "react-tags__selected",
            selectedTag: "react-tags__selected-tag",
            selectedTagName: "react-tags__selected-tag-name",
            search: "react-tags__search",
            searchInput: "react-tags__search-input",
            suggestions: "react-tags__suggestions",
            suggestionActive: "is-active",
            suggestionDisabled: "is-disabled",
          }}
        />

        <input
          type="hidden"
          defaultValue={JSON.stringify(this.state.tags)}
          // defaultValue={this.state.tags}
          name={this.state.name}
          {...this.state.attributes}
        ></input>
      </React.Fragment>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = this.state.defaultValue;

    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Tag;
